var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"100%","padding-top":"1px !important"},attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('v-row',{attrs:{"no-gutters":"","fill-height":""}},[_c('OrdersTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/views/Orders.vue?vue&type=template&id=a3d1c92c&
// module id = null
// module chunks = 